import React, { useState, useEffect } from "react";
import "./TopBar.scss";
import logo from "../../assets/kickthetires.ai.svg";
import kickthetiresMobileLogo from "../../assets/kickthetires.ai.mobile.svg"; // Path to the new mobile logo SVG
import { UserOutlined, DollarCircleOutlined } from "@ant-design/icons"; // Import Ant Design email icon
import { useNavigate, Link } from "react-router-dom";
import CreditsDashboard from "../../components/CreditDashboard/CreditDashboard";
import { useUser } from "../../context/UserContext";
import { Button, Modal } from "antd"; // Import Button and Modal from antd


interface TopBarProps {
  title: string;
  className?: string;
  children?: React.ReactNode; // Add children prop
}

const TopBar: React.FC<TopBarProps> = ({ title, className }) => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth); // State for storing window width
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCreditsModalVisible, setIsCreditsModalVisible] = useState(false);
  const navigate = useNavigate();
  const { user, credits } = useUser();


  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    window.open("https://app.pacer.co/", "_blank");
  };

  // Hook to handle window resize event
  useEffect(() => {
    // Function to update the window width state
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array to ensure this runs only once when component mounts


  const handleAccountClick = () => {
    navigate("/account"); // Navigate to the account page
  };

  const showCreditsModal = () => {
    setIsCreditsModalVisible(true);
  };

  const handleCreditsModalCancel = () => {
    setIsCreditsModalVisible(false);
  };

  return (
    <div className="top-bar">
      <div className="top-bar-left">
        <Link to="/">  {/* Route to home on click */}
          <img
            src={window.innerWidth <= 768 ? kickthetiresMobileLogo : logo} // Conditionally render mobile or full logo
            alt="Kick the tires Logo"
            className={`logo ${window.innerWidth <= 768 ? 'mobile-logo' : ''} `}
          />
        </Link>
      </div>
      <h1 className={`top-bar-title ${className || ''}`}>{ }</h1>
      {/* <div className="top-bar-right">
        {user && <a onClick={handleLogout}>Logout</a>}
      </div> */}
      <div className="top-bar-right-icon">
        {/* <Button className="home-icon"
          icon={<HomeOutlined style={{ fontSize: "24px" }} />}
          onClick={showModal}
          style={{ cursor: "pointer" }}
        /> */}
        {user && (
          <>
            <div className="credit-display">Credits: {credits}</div>
            {windowWidth <= 768 ? (
              <DollarCircleOutlined
                onClick={showCreditsModal}
                style={{ fontSize: "24px", cursor: "pointer", marginRight: "10px" }}
              />
            ) : (
              <Button type="primary" onClick={showCreditsModal}>
                Buy Credits
              </Button>
            )}

          </>
        )}
        <UserOutlined
          onClick={handleAccountClick}
          style={{ fontSize: "24px", cursor: "pointer" }}
        />
      </div>
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Yes"
        cancelText="No"
        closable={false}
      >
        <h3>Return to Pacer main site?</h3>
      </Modal>
      <Modal
        title="Credits Dashboard"
        visible={isCreditsModalVisible}
        onCancel={handleCreditsModalCancel}
        footer={null}
        width={800}
      >
        <CreditsDashboard />
      </Modal>
    </div>
  );
};

export default TopBar;

// {
//   window.innerWidth <= 768 ? (
//     // Show email icon on mobile
//     <a href="mailto:info@pacer.co">
//       <MailOutlined style={{ color: "#ffffff", fontSize: "1.5rem" }} />
//     </a>
//   ) : (
//     // Show full email on desktop
//     <a href="mailto:info@pacer.co">info@pacer.co</a>
//   );
// }
